import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LocationModalState {
  isOpen: boolean
  data: any
  initialData: any
  mode: 'add' | 'edit'
}

const initialState: LocationModalState = {
  isOpen: false,
  data: null,
  initialData: null,
  mode: 'add'
}
interface OpenModalPayload {
  data?: any
  mode?: 'add' | 'edit'
}

const locationModalSlice = createSlice({
  name: 'locationModal',
  initialState,
  reducers: {
    openLocationModal(state, action: PayloadAction<OpenModalPayload>) {
      state.isOpen = true
      state.data = action.payload.data || null
      state.mode = action.payload.mode || (action.payload.data ? 'edit' : 'add')
    },
    closeLocationModal(state) {
      state.isOpen = false
      state.data = null
      state.initialData = null
      state.mode = 'add'
    }
  }
})

export const { openLocationModal, closeLocationModal } = locationModalSlice.actions

export default locationModalSlice.reducer
